import React from 'react';

import PropTypes from 'prop-types';

import { Redirect } from 'react-router-dom';

import MuiPickersUtilsProvider from 'material-ui-pickers/utils/MuiPickersUtilsProvider';
import MomentUtils from 'material-ui-pickers/utils/moment-utils';

import { withStyles } from '@material-ui/core/styles';

import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Hidden from '@material-ui/core/Hidden';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';

import MenuIcon from '@material-ui/icons/Menu';
import Help from '@material-ui/icons/Help';
import ExitToApp from '@material-ui/icons/ExitToApp';

import { menuItems } from './tileData';

import Main from './components/Main';
import { auth, usersRef } from './firebase';

import { toast } from 'react-toastify';

const drawerWidth = 240;
const mobileDrawerWidth = '60%';

const styles = theme => ({
  root: {
    flexGrow: 1,
    zIndex: 1,
    height: '100vh',
    overflow: 'hidden',
    position: 'relative',
    display: 'flex',
  },
  loaderRoot: {
    position: 'fixed',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
  },
  loader: {
    width: '5rem',
    height: '40%',
    top: '30%',
    margin: '0 auto',
    position: 'relative',
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
  },
  drawerPaper: {
    [theme.breakpoints.up('md')]: {
      position: 'relative',
    },
    width: drawerWidth,
  },
  mobileDrawerPaper: {
    position: 'relative',
    width: mobileDrawerWidth,
  },
  drawerTitle: {
    paddingTop: '40px',
    paddingBottom: '40px',
    textAlign: 'center',
    fontSize: '30px',
  },
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing.unit * 3,
    minWidth: 0, // So the Typography noWrap works
  },
  toolbar: theme.mixins.toolbar,
  flex: {
    flex: 1,
  },
  rightIcon: {
    marginLeft: theme.spacing.unit,
  },
});

class App extends React.Component {
  state = {
    left: false,
    redirect: false,
    loading: true,
  };

  constructor() {
    super();
    auth.onAuthStateChanged(() => {
      usersRef.where('email', '==', auth.currentUser.email).get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            console.log('User id: ' + doc.id);
            this.setState({
              myId: doc.id,
              loading: false,
            });
          });

        });
    })
  }

  componentWillMount() {
  }

  logout = () => {
    auth.signOut().then(() => {
      /* Push.create("KBAAZ", {
        body: "Logout successful!!!",
        logo: './k-logo.png',
        timeout: 4000,
        onClick: function () {
          window.focus();
          this.close();
        }
      }); */
      toast.success('Logout successful!', {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      this.setState({
        redirect: true,
      })
    });
  }

  render() {
    const { classes } = this.props;
    if (this.state.loading) {
      return (
        <div className={classes.loaderRoot}>
          <div className={classes.loader}>
            <CircularProgress />
          </div>
        </div>
      );
    }

    if (this.state.redirect) {
      return (
        <Redirect to='/' />
      )
    }

    const drawer = (
      <div >
        <div className={classes.toolbar} />
        <div className={classes.drawerTitle}>
          KBAAZ
        </div>
        <Divider />
        <List onClick={() => { this.setState({ left: false }) }}>{menuItems}</List>
      </div>
    );
    return (
      <div className={classes.root}>
        <AppBar position="fixed" className={classes.appBar}>
          <Toolbar>
            <Hidden mdUp>
              <IconButton onClick={() => { this.setState({ left: true }) }} className={classes.menuButton} color="inherit" aria-label="Menu">
                <MenuIcon />
              </IconButton>
            </Hidden>
            <Typography variant="title" color="inherit" className={classes.flex}>
              KBAAZ
            </Typography>
            <Button onClick={this.logout} color="inherit">
              Logout
              <ExitToApp className={classes.rightIcon} />
            </Button>

            {/* 
            <Button color="inherit">
              Help
              <Help className={classes.rightIcon} />
            </Button>
             */}
          </Toolbar>
        </AppBar>
        <Hidden smDown>
          <Drawer
            variant="permanent"
            classes={{
              paper: classes.drawerPaper,
            }}
          >
            {drawer}
          </Drawer>
        </Hidden>
        <Drawer classes={{ paper: classes.drawerPaper }} open={this.state.left} onClose={() => { this.setState({ left: false }) }}>
          {drawer}
        </Drawer>
        <main className={classes.content}>
          <div className={classes.toolbar} />
          <MuiPickersUtilsProvider utils={MomentUtils}>
            <Main myId={this.state.myId} />
          </MuiPickersUtilsProvider>
        </main>
      </div>
    );
  }
}

App.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(App);


// WEBPACK FOOTER //
// ./src/App.js